function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenZLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    id: "marker6859",
    refX: 0,
    refY: 0,
    orient: "auto-start-reverse",
    markerWidth: 4.0606604,
    markerHeight: 6.7071066,
    viewBox: "0 0 4.0606602 6.7071068",
    preserveAspectRatio: "xMidYMid"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "context-stroke",
      strokeWidth: 1,
      strokeLinecap: "butt"
    },
    d: "M 3,-3 0,0 3,3",
    id: "path6857",
    transform: "rotate(180,0.125,0)"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    id: "marker6545",
    refX: 0,
    refY: 0,
    orient: "auto-start-reverse",
    markerWidth: 4.0609999,
    markerHeight: 6.7076674,
    viewBox: "0 0 4.0606602 6.7071068",
    preserveAspectRatio: "xMidYMid"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "context-stroke",
      strokeWidth: 1,
      strokeLinecap: "butt"
    },
    d: "M 3,-3 0,0 3,3",
    id: "path6543",
    transform: "rotate(180,0.125,0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4739",
    style: {
      fill: "none",
      stroke: "#ff2a2f",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      paintOrder: "normal",
      strokeOpacity: 1,
      markerEnd: "url(#marker6859)"
    },
    d: "M 84.573203 204.68759 A 371 371 0 0 1 400 29 A 371 371 0 0 1 715.59243 204.95535 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4735",
    style: {
      fill: "none",
      stroke: "#ff2a2f",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      markerEnd: "url(#marker6545)",
      strokeOpacity: 1
    },
    d: "M 716.0587 594.28819 A 371 371 0 0 1 400 771 A 371 371 0 0 1 83.941311 594.2882 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "text8512",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 900,
      fontStretch: "normal",
      fontSize: "410.929px",
      fontFamily: "Montserrat",
      InkscapeFontSpecification: "'Montserrat Heavy'",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#607196",
      fillOpacity: 1,
      stroke: "#35ada6",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M 426.71094 249.59961 C 395.20644 249.59961 367.3988 255.90016 343.29102 268.50195 C 319.45718 281.10375 300.82794 299.32241 287.4043 323.15625 C 277.80351 340.00662 271.65603 359.46462 268.92188 381.5 L 490.90625 381.5 C 485.21888 376.72017 478.89334 372.60683 471.91211 369.17969 C 457.11869 361.50903 440.95481 357.67383 423.42188 357.67383 C 409.99822 357.67383 398.21826 359.45425 388.08203 363.01562 C 379.92877 365.65993 372.66398 369.37128 366.2832 374.14258 C 368.7272 361.01471 373.93419 350.45449 381.91797 342.4707 C 393.69791 330.69076 409.31503 324.80078 428.76562 324.80078 C 437.80605 324.80078 446.57194 325.89627 455.06445 328.08789 C 463.83092 330.00556 472.46061 333.97695 480.95312 340.00391 L 515.88086 272.20117 C 504.92277 265.07842 491.50055 259.59901 475.61133 255.76367 C 459.99605 251.6544 443.69597 249.59961 426.71094 249.59961 z M 669.1582 249.59961 C 643.68066 249.59961 621.08002 255.48959 601.35547 267.26953 C 581.90487 279.04947 566.56212 296.17264 555.33008 318.63672 C 546.56361 336.60798 541.31384 357.56754 539.56055 381.5 L 598.13477 381.5 A 72.939888 124.30601 0 0 1 670.18555 275.69336 A 72.939888 124.30601 0 0 1 742.29688 381.5 L 798.73828 381.5 C 796.94116 357.56753 791.55985 336.60798 782.57422 318.63672 C 771.61613 296.17264 756.27533 279.04947 736.55078 267.26953 C 717.10018 255.48959 694.63575 249.59961 669.1582 249.59961 z M 15.371094 256.17578 L 15.371094 329.32031 L 118.2207 329.32031 L 75.777344 372.4668 L 75.777344 381.5 L 206.28516 381.5 C 197.76991 376.34091 187.96063 372.39219 176.84961 369.66406 L 229.875 315.75977 L 229.875 256.17578 L 15.371094 256.17578 z M 75.777344 418.5 L 75.777344 432.05273 L 113.99414 432.05273 C 126.32199 432.05273 135.08787 433.83315 140.29297 437.39453 C 145.49805 440.68196 148.10156 445.47645 148.10156 451.77734 C 148.10156 459.17406 144.53877 464.78967 137.41602 468.625 C 130.56721 472.18638 121.66512 473.9668 110.70703 473.9668 C 98.653139 473.9668 85.777683 472.32257 72.080078 469.03516 C 58.656425 465.47378 45.779017 460.13252 33.451172 453.00977 L 0.578125 524.51172 C 15.919443 533.00423 33.725591 539.44098 53.998047 543.82422 C 74.270503 548.20745 94.269589 550.40039 113.99414 550.40039 C 144.67678 550.40039 169.60656 545.6059 188.7832 536.01758 C 208.2338 526.42925 222.47911 514.10057 231.51953 499.0332 C 240.8339 483.96584 245.49023 468.21448 245.49023 451.77734 C 245.49023 439.62451 243.3361 428.53354 239.03516 418.5 L 75.777344 418.5 z M 267.4668 418.5 C 268.52832 445.58384 274.20651 468.60223 284.5293 487.52734 C 296.30924 508.3477 312.47117 524.10102 333.01758 534.78516 C 353.83794 545.19534 377.94658 550.40039 405.3418 550.40039 C 426.98402 550.40039 446.57254 546.29083 464.10547 538.07227 C 481.91235 529.85369 496.01951 518.20994 506.42969 503.14258 C 516.83987 488.07521 522.04492 470.26906 522.04492 449.72266 C 522.04492 438.37477 520.35492 427.97198 516.99805 418.5 L 267.4668 418.5 z M 539.56055 418.5 C 541.31384 442.43246 546.56361 463.39202 555.33008 481.36328 C 566.56212 503.82736 581.90487 520.95053 601.35547 532.73047 C 621.08002 544.51041 643.68066 550.40039 669.1582 550.40039 C 694.63575 550.40039 717.10018 544.51041 736.55078 532.73047 C 756.27533 520.95053 771.61613 503.82736 782.57422 481.36328 C 791.55985 463.39202 796.94116 442.43247 798.73828 418.5 L 742.23633 418.5 A 72.939888 124.30601 0 0 1 670.18555 524.30664 A 72.939888 124.30601 0 0 1 598.13477 418.5 L 539.56055 418.5 z M 398.76758 424.65625 C 407.53404 424.65625 414.65572 427.39596 420.13477 432.875 C 425.6138 438.08009 428.35352 445.20177 428.35352 454.24219 C 428.35352 460.26913 427.12182 465.47419 424.65625 469.85742 C 422.19068 474.24066 418.62789 477.66529 413.9707 480.13086 C 409.58747 482.32248 404.52057 483.41797 398.76758 483.41797 C 393.01458 483.41797 387.94574 482.32248 383.5625 480.13086 C 379.17926 477.66529 375.61842 474.24066 372.87891 469.85742 C 370.41333 465.47419 369.17969 460.26913 369.17969 454.24219 C 369.17969 448.21524 370.41333 443.01019 372.87891 438.62695 C 375.61842 434.24372 379.17926 430.81908 383.5625 428.35352 C 387.94574 425.88794 393.01458 424.65625 398.76758 424.65625 z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenZLogo);
export default __webpack_public_path__ + "static/media/GenZ_Logo.d20c1044b6a69715d44b5182dd6a2aaa.svg";
export { ForwardRef as ReactComponent };